
import { Vue, Component } from 'vue-property-decorator';
import { Loading, Toast } from 'vant';

Vue.use(Loading);

@Component
export default class Home extends Vue {
  loading: boolean = true;
  baseInfo: any = {};
  mounted() {
    // setTimeout(() => {
    //   this.loading = false;
    // }, 1000);
    (this.$refs.img as HTMLImageElement).onload = () => {
      this.loading = false;
    };
  }
  handleClickUpload(val: string) {
    this.$router.push({
      path: val,
    });
  }
  jumpLink(link: string) {
    window.location.href = link;
  }
}
